import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFavicon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 216 216",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("style", { children: "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n    " }),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "linear-gradient",
				x1: 172.63,
				y1: 78.11,
				x2: 172.63,
				y2: 6.2,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#4875cf"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6592fd"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "linear-gradient-2",
				x1: 172.58,
				y1: 210.11,
				x2: 172.58,
				y2: 138.06,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: 0,
						stopColor: "#2d5295"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .04,
						stopColor: "#30559b"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .33,
						stopColor: "#4875cf"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .49,
						stopColor: "#4471c8"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .71,
						stopColor: "#3c66b6"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .97,
						stopColor: "#2e5498"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#2d5295"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "linear-gradient-3",
				x1: 64.31,
				y1: 209.83,
				x2: 64.31,
				y2: 5.89,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: 0,
						stopColor: "#2d5295"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .03,
						stopColor: "#3c63b1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .07,
						stopColor: "#4b74cd"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .11,
						stopColor: "#5681e2"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .16,
						stopColor: "#5e8af1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .22,
						stopColor: "#6390fa"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .3,
						stopColor: "#6592fd"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .37,
						stopColor: "#618ef6"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .48,
						stopColor: "#5782e4"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .59,
						stopColor: "#4770c6"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .73,
						stopColor: "#31579d"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .75,
						stopColor: "#2d5295"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "linear-gradient-4",
				x1: 64.31,
				y1: 108.02,
				x2: 64.31,
				y2: 5.89,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .5,
						stopColor: "#6592fd"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6,
						stopColor: "#5c88ed"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .79,
						stopColor: "#4770c6"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#2d5295"
					})
				]
			})
		] }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "m179.23,39.16c9.81-12.7,22.4-23.19,36.53-29.73-30.55-11.28-67.71,8.23-86.26,39.13l21.45,29.55,28.28-38.95Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-4",
			d: "m179.23,177.15l-28.37-39.09-21.45,29.55c18.55,30.95,55.75,50.58,86.35,39.26-14.14-6.54-26.72-17.02-36.53-29.73Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-2",
			d: "m107.24,79.22C81.09,42.6,53.24-7.7.24,9.29c12.11,5.35,23.39,14.22,32.31,26.15,11.28,15.57,41.87,57.74,52.93,72.58-10.91,14.64-41.78,57.19-52.93,72.58-8.92,11.92-20.2,20.8-32.31,26.15,25.52,9.08,58.55-2.51,75.21-26.15,13.22-18.23,39.77-54.87,52.93-72.58-3.2-4.35-18.34-24.86-21.15-28.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-3",
			d: "m128.39,108.02c-3.2-4.35-18.34-24.86-21.15-28.8C81.09,42.6,53.24-7.7.24,9.29c12.11,5.35,23.39,14.22,32.31,26.15,11.28,15.57,41.87,57.74,52.93,72.58h42.9Z"
		})
	]
});
export default SvgFavicon;
